import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { BASE_URL } from '../../utils/axios';
import { parsePaginatedResponse } from '../../utils/pagination';

export const projectsApi = createApi({
  reducerPath: 'projectsApi',
  tagTypes: ['Projects'],
  keepUnusedDataFor: 600,
  endpoints: (builder) => ({
    getProjects: builder.query({
      async queryFn() {
        try {
          const { data } = await axios.get(`${BASE_URL}/api/v1/projects/`);
          return { data: parsePaginatedResponse({ data }) };
        } catch (e) {
          return {
            error: {
              status: e.response?.status,
              data: e.response?.data ?? e.message,
            },
          };
        }
      },
      providesTags: [{ type: 'Projects', id: 'LIST' }],
    }),
  }),
});

export const { useGetProjectsQuery } = projectsApi;
